
export default {
    props: {
        city: Object,
    },
    methods: {
        roundToHalf(value) {
            let rounded = (Math.round(value * 2) / 2).toFixed(1);
            // If the rounded value ends with '.0', remove it.
            return rounded.endsWith('.0') ? rounded.substring(0, rounded.length - 2) : rounded;
        },
        redirectToNewReview: function (idx) {
            this.$router.push({
                name: 'post-avis',
                query: { city: this.cities[idx].city.slug, global: this.scoreGlobal[idx] }
            });
        },
        getLabelForNewReview(idx) {
            return 'Evaluez ' + this.cities[idx].city.full_name;
        },
    },
}
